import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
// Must load BEFORE anything else so its capture-phase `error` listener is
// the first one registered — it silences the anonymised "Script error."
// dispatches that Cloudflare RUM / third-party beacons emit on the preview
// host. Legitimate errors from our own code fall through untouched.
import "@/lib/crossOriginErrorSuppressor";
import { registerServiceWorker } from "@/lib/registerServiceWorker";
import App from "@/App";

// Register the SW proactively so version bumps in `public/sw.js` can purge
// stale browser caches AND reload any tab still running the old bundle.
registerServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
